import { createAction, createSlice } from "@reduxjs/toolkit";

const subscribeSlice = createSlice({
  name: "subscribe",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = subscribeSlice;
const subscribeAction = createAction(name);

export {
  subscribeAction,
  actions as subscribeActions,
  reducer as subscribeReducer,
};
